type AnyFunction = (...args: any) => any;

/**
 * Returns a new function that waits for a specified amount of time before calling the original function.
 * If the function is called again before the specified delay, the previous call is cancelled.
 * @param fn The function to be debounced.
 * @param delay The delay time in milliseconds.
 * @returns The debounced function.
 */
export function debounce<FunctionReturnType extends AnyFunction>(
	fn: AnyFunction,
	delay: number
): FunctionReturnType {
	let timeout: NodeJS.Timeout;

	return function (...args: any[]) {
		if (timeout) clearTimeout(timeout);

		timeout = setTimeout(() => fn(...args), delay);
	} as unknown as FunctionReturnType;
}
